// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"7846b366","990":"4b925a6d"}[chunkId] + ".chunk.js";
};